namespace $ {
	export type $shm_projects_digest_project = {
		id: string
		title: string
		archived?: boolean
		history: readonly { id: string, version: string, date: string, stage: string, changes: unknown }[]
	}
	export type $shm_projects_digest_record = {
		kind: 'day' | 'week'
		start: string
		end: string
		slot: string
		content?: string
		notes?: $shm_projects_release_notes
	}

	export function $shm_projects_digest_shift( day: string, offset: number ) {
		const date = new Date( day + 'T12:00:00Z' )
		date.setUTCDate( date.getUTCDate() + offset )
		return date.toISOString().slice( 0, 10 )
	}

	export function $shm_projects_digest_week( day: string ) {
		return $shm_projects_digest_shift( day, -( new Date( day + 'T12:00:00Z' ).getUTCDay() + 6 ) % 7 )
	}

	/** Midnight closes the previous day, including the previous week on Monday. */
	export function $shm_projects_digest_slot( now: number, timezone = 'Europe/Moscow' ) {
		const parts = Object.fromEntries( new Intl.DateTimeFormat( 'en-GB', {
			timeZone: timezone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23',
		} ).formatToParts( now ).map( part => [ part.type, part.value ] ) )
		const date = `${parts.year}-${parts.month}-${parts.day}`
		const midday = Number( parts.hour ) >= 11
		return { id: `${date}T${midday ? '11' : '00'}:00`, day: midday ? date : $shm_projects_digest_shift( date, -1 ) }
	}

	export function $shm_projects_digest_source( projects: readonly $shm_projects_digest_project[], start: string, end: string ) {
		const prereleases = projects.filter( project => !project.archived ).flatMap( project => {
			const seen = new Set<string>()
			return project.history.filter( item => item.stage === 'Пререлиз' ).flatMap( item => {
				const date = item.date.replace( /^(\d{2})\.(\d{2})\.(\d{4})$/, '$3-$2-$1' ).slice( 0, 10 )
				if( date < start || date > end || seen.has( item.version ) ) return []
				seen.add( item.version )
				return [{ id: `${project.id}/${item.id}`, project: project.title, version: item.version, date, changes: item.changes }]
			} )
		} ).sort( ( a, b )=> a.date.localeCompare( b.date ) || a.id.localeCompare( b.id ) )
		return { project: 'Все проекты', version: `${start} — ${end}`, previous_version: null, prereleases } satisfies $shm_projects_release_notes_source
	}
}
